export class Quiz {
    id: any;
    storedid:any;
    quizname: string;
    json:string;
    quiztitledesc:string;
    ispublished:number;
    length: number;
    startdate: any;
  enddate: any;
  createddate: Date;
  createdby: any;
  Isedit: number;
  _id: any;
  totolrows: number;
  studentrestriction: number;
  }
